import React from "react";
import { ReactNode, useState } from "react";
import { createContext } from "react";
import { useHistory } from "react-router-dom";
import useAuthData from "../../../../../../hook/useAppData";
import { data } from "../constants";
import { EletronicInventoryStoreProps, IEletronicInventory } from "../models";

interface StoreProviderProps {
  children: ReactNode;
}

export const EletronicInventoryStore = createContext({} as EletronicInventoryStoreProps);

export function EletronicInventoryStoreProvider({ children }: StoreProviderProps) {
  const { token } = useAuthData();
  const [file, setFile] = useState<any>();
  const [defaultValues, setDefaultValues] = useState(data as IEletronicInventory);
  const [state, setState] = useState(false);

  const [listUsers, setListUsers] = useState([]);

  const [createOrUpdate, setCreateOrUpdate] = useState<"create" | "update">("create");
  const [needSpinner, setNeedSpinner] = useState(true);

  const history = useHistory();

  function saveDataOfField(event) {
    let { value, name } = event;
    setDefaultValues({ ...defaultValues, [`${name}`]: value });
  }

  function handleExitClick() {
    history.push("/eletronic-inventory");
  }

  return (
    <EletronicInventoryStore.Provider
      value={{
        token,
        defaultValues,
        setDefaultValues,
        createOrUpdate,
        setCreateOrUpdate,
        needSpinner,
        setNeedSpinner,
        state,
        setState,
        listUsers,
        setListUsers,
        handleExitClick,
        saveDataOfField,
        file,
        setFile,
      }}
    >
      {children}
    </EletronicInventoryStore.Provider>
  );
}
